import { IRootState } from '../../../store'

export const getRootStateSelector = (state: IRootState): IRootState => state
